import React from "react";
import styled from "styled-components";
import "./styles.css";

// Styles

const DepartureDateDisplay = styled.div`
  font-size: 14px;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
const Location = styled.span`
  font-size: 16px;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

let TripSegmentHeader = ({
  // title,
  departureDateDisplay,
  destinationAirportState,
  destinationAirportCity,
  originAirportState,
  originAirportCity
}) => (
  <div>
    <hr />
    {/* <div class="trip-segment-header">{title}</div> */}

    <DepartureDateDisplay> {departureDateDisplay} </DepartureDateDisplay>
    <Location>
      {originAirportCity}, {originAirportState} to {destinationAirportCity},{" "}
      {destinationAirportState}
    </Location>
    <hr />
  </div>
);

export default TripSegmentHeader;



// WEBPACK FOOTER //
// ./src/components/TripSegmentHeader/index.js